export const FONT_PROXIMA_NOVA = 'proxima-nova, Helvetica, Arial, sans-serif';
